<template>
  <b-container class="d-flex flex-column h-100" fluid>
    <div
      class="pagetitle-container d-flex justify-content-start align-items-center"
    >
      <div class="page-title">
        <h2>
          Užívatelia
          <small>({{ count }})</small>
        </h2>
      </div>
      <div class="d-flex flex-grow-1">
        <input-filter
          ref="filter"
          :filters="table.filter"
          :options="filterOptions"
          @onReset="resetFilter"
          @onSearch="search"
        >
          <template #filter>
            <b-row>
              <b-col md="4">
                <b-form-group
                  label="Stav:"
                  label-align-md="right"
                  label-cols-md="4"
                  label-for="state"
                >
                  <b-input-group class="input-group-labeled">
                    <selectbox
                      v-model="table.filter.active"
                      :options="[
                        { id: 1, name: 'Aktívny' },
                        { id: 0, name: 'Neaktívny' },
                      ]"
                      :searchable="false"
                      @input="search"
                    />
                    <b-input-group-append>
                      <b-btn
                        size="sm"
                        variant="link"
                        @click="
                          table.filter.active = null
                          search()
                        "
                      >
                        <b-icon icon="x" scale="1.5x" />
                      </b-btn>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
          </template>
        </input-filter>
      </div>
      <div v-if="$root.user.isAdmin" class="ml-3">
        <b-dropdown
          class="mr-1"
          menu-class="dropdown-menu-animated"
          right
          size="lg"
          variant="secondary"
        >
          <template #button-content>
            <b-icon icon="gear" />
          </template>
          <b-dropdown-item-button @click="exportUsers">
            <b-icon class="mr-1" icon="file-earmark-spreadsheet" />
            Exportovať
          </b-dropdown-item-button>
        </b-dropdown>
        <b-btn
          class="text-uppercase"
          size="lg"
          variant="primary"
          @click="openAddUserModal"
        >
          <b-icon class="mr-1" icon="plus" scale="1.5x" />
          Nový užívateľ
        </b-btn>
      </div>
    </div>
    <add-user ref="userForm" />
    <div ref="scroll" v-bar class="bar-out">
      <div>
        <server-table
          ref="table"
          :api-request="apiRequest"
          :columns="table.columns"
          :searchable="false"
          :sort-by.sync="table.sortBy"
          bordered
          hover
          striped
          class="table-middle"
          @refreshed="onLoaded"
        >
          <template #cell(actions)="data">
            <b-dropdown class="btn-p-0" no-caret variant="link">
              <template slot="button-content">
                <b-icon icon="text-indent-left" scale="1.25x" />
              </template>
              <b-dropdown-item @click="generatePass(data.item.id)">
                Vygenerovať heslo
              </b-dropdown-item>
              <b-dropdown-item @click="edit(data.item.id)">
                Upraviť
              </b-dropdown-item>
              <b-dropdown-item
                v-if="data.item.active"
                link-class="text-danger"
                @click.prevent="deactivate(data.item.id)"
              >
                Deaktivovať
              </b-dropdown-item>
              <b-dropdown-item
                v-else
                link-class="text-success"
                @click.prevent="activate(data.item.id)"
              >
                Aktivovať
              </b-dropdown-item>
              <!--<b-dropdown-item
                v-b-modal.modalFH-energeticslist
                @click="restrictions = props.row.restriction_list"
              >
                Zobraziť odberné miesta
              </b-dropdown-item>-->
            </b-dropdown>
          </template>
          <template #cell(user)="data">
            <b-avatar
              :text="
                $options.filters.initials(
                  `${data.item.firstname} ${data.item.lastname}`,
                )
              "
              :src="`/storage/avatars/${data.item.avatar}_xs.jpg`"
              size="35px"
              variant="light"
              class="no-outline mr-2"
            />
            <span class="text-nowrap">
              {{ data.item.firstname }} {{ data.item.lastname }}
              <b-badge
                v-if="!data.item.active"
                variant="danger"
                class="align-middle"
              >
                NEAKTÍVNY
              </b-badge>
              <b-badge
                v-if="data.item.roles && data.item.roles[0].name === 'admin'"
                variant="primary"
                class="ml-1 align-top"
              >
                Administrátor
              </b-badge>
            </span>
          </template>
          <template #cell(restrictionList)="data">
            <template v-if="data.value.length">
              <span
                v-if="data.value.filter((val) => val.powerNumber).length"
                class="mr-1"
              >
                <b-badge class="bg-power align-top">
                  <icon class="icon-fw" name="plug" scale="0.675" />
                </b-badge>
                {{ data.value.filter((val) => val.powerNumber).length }}
              </span>
              <span
                v-if="data.value.filter((val) => val.gasNumber).length"
                class="mr-1"
              >
                <b-badge class="bg-gas align-top">
                  <icon class="icon-fw" name="fire" scale="0.675" />
                </b-badge>
                {{ data.value.filter((val) => val.gasNumber).length }}
              </span>
              <span
                v-if="data.value.filter((val) => val.waterNumber).length"
                class="mr-1"
              >
                <b-badge class="bg-water align-top">
                  <icon class="icon-fw" name="tint" scale="0.675" />
                </b-badge>
                {{ data.value.filter((val) => val.waterNumber).length }}
              </span>
              <span
                v-if="data.value.filter((val) => val.heatNumber).length"
                class="mr-1"
              >
                <b-badge class="bg-heat align-top">
                  <icon class="icon-fw" name="sun" scale="0.675" />
                </b-badge>
                {{ data.value.filter((val) => val.heatNumber).length }}
              </span>
            </template>
            <template v-else> -</template>
          </template>
        </server-table>
      </div>
    </div>
    <!--<modal
      ref="energeticsModal"
      hide-footer
      size="sm"
      title="Odberné miesta"
      @hidden="searchRestriction = ''"
      @shown="$vuebar.refreshScrollbar($refs.scroll, {})"
    >
      <b-form-input
        id="searchEnergetics"
        v-model="searchRestriction"
        class="form-control mb-3"
        placeholder="Filtrovanie a hľadanie..."
        type="text"
        @keydown.enter.native="searchEnergetics()"
      />
      <div
        ref="scroll"
        v-bar
      >
        <div>
          <div class="list-group">
            <div
              v-for="energetic in filteredRestrictions"
              :key="energetic.id"
              class="list-group-item flex-column align-items-start"
            >
              <div class="d-flex w-100 justify-content-between">
                <h5
                  class="m-0"
                >
                  {{ energetic.powerNumber || energetic.gasNumber || energetic.waterNumber || energetic.heatNumber }}
                </h5>
              </div>
            </div>
          </div>
        </div>
      </div>
    </modal>-->
  </b-container>
</template>
<script>
import InputFilter from '@/components/InputFilter'
import Selectbox from '@/components/inputs/Selectbox'
import ServerTable from '@/components/ServerTable'
import Modal from '@/components/Modal'
import AddUser from './Add'
import { saveAs } from 'file-saver'

export default {
  components: {
    InputFilter,
    Selectbox,
    ServerTable,
    Modal,
    AddUser,
  },
  data() {
    return {
      loading: false,
      users: [],
      table: {
        columns: [
          {
            key: 'actions',
            label: '',
            class: 'th-shrink',
          },
          {
            key: 'user',
            label: 'Meno a Priezvisko',
            sortable: true,
            atter: (value, key, item) =>
              item.firstname + ' ' + item.lastname || '-',
            sortableKey: 'firstname, lastname',
            searchable: true,
          },
          {
            key: 'company',
            label: 'Názov spoločnosti',
            formatter: (value, key, item) => item.companyName || '-',
            sortable: true,
            sortableKey: 'companies.name',
            searchable: true,
          },
          {
            key: 'email',
            label: 'Email',
            formatter: (value, key, item) => item.email || '-',
            sortable: true,
            sortableKey: 'users.email',
            searchable: true,
          },
          {
            key: 'phone',
            label: 'Telefón',
            formatter: (value, key, item) => item.phone || '-',
            sortable: true,
            sortableKey: 'users.phone',
            searchable: true,
          },
          {
            key: 'restrictionList',
            label: 'Odberné miesta',
          },
        ],
        sortBy: 'user',
        filter: {
          active: null,
        },
      },
      filterOptions: {
        placeholder: 'Filtrovanie a hľadanie...',
      },
      count: null,
      searchRestriction: '',
      restrictions: [],
    }
  },
  computed: {
    filteredRestrictions() {
      if (this.restrictions) {
        return this.restrictions.filter((val) => {
          for (let search of [
            'powerNumber',
            'gasNumber',
            'waterNumber',
            'heatNumber',
          ]) {
            if (val[search]) {
              return val[search]
                .toLowerCase()
                .includes(this.searchRestriction.toLowerCase())
            }
          }
        })
      }
      return null
    },
  },
  mounted() {
    this.$root.$on('reloadUserData', this.$refs.table.refresh)
  },
  beforeDestroy() {
    this.$root.$off('reloadUserData')
  },
  methods: {
    apiRequest(params) {
      return this.$api.get('users/get_list', {
        params: { filter: this.table.filter, ...params },
      })
    },
    onLoaded() {
      this.count = this.$refs.table.totalRows
    },
    search() {
      this.$refs.table.searchVal = this.$refs.filter.value
      this.$nextTick(() => {
        this.$refs.table.search()
      })
    },
    resetFilter() {
      this.$refs.table.reset()
    },
    openAddUserModal() {
      this.$root.$emit('modal-show', 'add-user')
    },
    edit(id) {
      this.$refs.userForm.edit = true
      this.$refs.userForm.form.id = id
      this.$nextTick(() => {
        this.openAddUserModal()
      })
    },
    activate(id) {
      this.$api
        .post('users/activate', {
          id: id,
        })
        .then(() => {
          this.$refs.table.refresh()
        })
    },
    deactivate(id) {
      this.$api
        .post('users/deactivate', {
          id: id,
        })
        .then(() => {
          this.$refs.table.refresh()
        })
    },
    generatePass(id) {
      this.$swal({
        title: 'Generovať heslo',
        text: 'Naozaj chcete vygenerovať nové heslo pre užívateľa?',
        type: 'info',
        position: 'top',
        showConfirmButton: true,
        showCancelButton: true,
      }).then((result) => {
        if (result.value) {
          this.$api
            .post('users/generate_pass', {
              id: id,
              password: this.$helpers.generatePass(),
              sendmail: true,
            })
            .then(() => {
              this.$swal({
                toast: true,
                type: 'success',
                position: 'top-end',
                title: 'Nové heslo bolo úspešne vygenerované',
                timer: 5000,
              })
            })
        }
      })
    },
    exportUsers() {
      this.$swal({
        toast: true,
        type: 'info',
        position: 'top-end',
        title: 'Pripravujem export...',
      })
      this.$api
        .get('users/export', {
          params: {
            query: this.$refs.filter.value,
            filter: this.table.filter,
            ...this.$refs.table.getRequestParams(),
            startAt: 0,
            maxResults: -1,
          },
          responseType: 'blob',
        })
        .then((res) => {
          saveAs(new Blob([res.data]), 'uzivatelia.xlsx')
          this.$swal({
            toast: true,
            type: 'success',
            position: 'top-end',
            title: 'Export pripravený',
            timer: 5000,
          })
        })
        .catch(() => {
          this.$swal({
            toast: true,
            type: 'error',
            position: 'top-end',
            title: 'Chyba pri exportovaní',
            timer: 5000,
          })
        })
    },
  },
}
</script>
